import RadarChart from './components/RadarChart';

export default RadarChart;



// WEBPACK FOOTER //
// ./src/lib/index.js